import styled from 'styled-components';

import Img from 'components/Img';

const StyledImg = styled(Img)`
  width: 100%;
  height: 100%;
`;

StyledImg.defaultProps = {
  scaleMode: 'cover',
  position: '100% 50%',
};

export default StyledImg;